export default "__VITE_ASSET__BRbiXsgh__"